import { Module, VuexModule, Mutation } from 'vuex-module-decorators'
import { SettingSubscription } from '~/graphql/types'

@Module({
  name: 'setting',
  stateFactory: true,
  namespaced: true,
})
export default class Setting extends VuexModule {
  loading = true
  items: SettingSubscription['setting'] = []

  @Mutation
  setLoading(loading) {
    this.loading = loading
  }

  @Mutation
  setItems(items) {
    this.items = items
  }
}
